import apiClient, { getApiUrl } from './client.js';
import { handleApiError } from '@/services/utils/errorHandler.js';
import AuthService from '@/services/auth/authService.js';

import { BudgetService } from './budget.js';
import { TripsService } from './trips.js';
import { ActivitiesService } from './activities.js';
import { HealthService } from './health.js';
import { TripFinderService } from './tripfinder.js';
import { TrendingService } from './trending.js';
import { DestinationsService } from './destinations.js';
import { PlacesService } from './places.js';

const authService = new AuthService(apiClient, handleApiError);
const budgetService = new BudgetService(apiClient, handleApiError);
const tripsService = new TripsService(apiClient, handleApiError);
const activitiesService = new ActivitiesService(apiClient, handleApiError);
const healthService = new HealthService(apiClient, handleApiError);
const tripFinderService = new TripFinderService(apiClient, handleApiError);
const trendingService = new TrendingService(apiClient, handleApiError);
const destinationsService = new DestinationsService(apiClient, handleApiError);
const placesService = new PlacesService(apiClient, handleApiError);

export const apiService = {
  register: authService.register.bind(authService),
  login: authService.login.bind(authService),
  logout: authService.logout.bind(authService),
  getCurrentUser: authService.getCurrentUser.bind(authService),
  updateUserProfile: authService.updateUserProfile.bind(authService),
  uploadProfilePicture: authService.uploadProfilePicture.bind(authService),
  changePassword: authService.changePassword.bind(authService),
  deleteAccount: authService.deleteAccount.bind(authService),
  forgotPassword: authService.forgotPassword.bind(authService),
  resetPassword: authService.resetPassword.bind(authService),
  validateResetToken: authService.validateResetToken.bind(authService),
  resendVerificationEmail: authService.resendVerificationEmail.bind(authService),
  verifyEmail: authService.verifyEmail.bind(authService),
  isAuthenticated: authService.isAuthenticated.bind(authService),
  getAuthToken: authService.getAuthToken.bind(authService),

  getBudgetEstimation: budgetService.getBudgetEstimation.bind(budgetService),
  saveBudgetPlan: budgetService.saveBudgetPlan.bind(budgetService),
  getDestinationCostInfo: budgetService.getDestinationCostInfo.bind(budgetService),

  getSavedTrips: tripsService.getSavedTrips.bind(tripsService),
  deleteTrip: tripsService.deleteTrip.bind(tripsService),
  getTrip: tripsService.getTrip.bind(tripsService),
  updateTrip: tripsService.updateTrip.bind(tripsService),
  createTrip: tripsService.createTrip.bind(tripsService),

  getActivities: activitiesService.getActivities.bind(activitiesService),
  getRestaurants: activitiesService.getRestaurants.bind(activitiesService),
  searchRestaurants: activitiesService.searchRestaurants.bind(activitiesService),
  getAccommodations: activitiesService.getAccommodations.bind(activitiesService),
  searchActivities: activitiesService.searchActivities.bind(activitiesService),

  buildTrip: tripFinderService.buildTrip.bind(tripFinderService),
  buildTripStream: tripFinderService.buildTripStream.bind(tripFinderService),
  recommendDestinations: tripFinderService.recommendDestinations.bind(tripFinderService),
  searchNearby: tripFinderService.searchNearby.bind(tripFinderService),
  getTripFinderModes: tripFinderService.getAvailableModes.bind(tripFinderService),
  tripFinderHealthCheck: tripFinderService.healthCheck.bind(tripFinderService),

  getTrendingDestinations: trendingService.getTrendingDestinations.bind(trendingService),

  getHealthStatus: healthService.getHealthStatus.bind(healthService),
  getVersion: healthService.getVersion.bind(healthService),
  ping: healthService.ping.bind(healthService),

  getDestinationImage: destinationsService.getDestinationImage.bind(destinationsService),
  getDestinationBasicInfo: destinationsService.getDestinationBasicInfo.bind(destinationsService),
  getDestinationDetails: destinationsService.getDestinationDetails.bind(destinationsService),
  getBestTimeToVisit: destinationsService.getBestTimeToVisit.bind(destinationsService),
  getAccommodationsLive: destinationsService.getAccommodations.bind(destinationsService),
  getRestaurantsLive: destinationsService.getRestaurants.bind(destinationsService),
  getAttractionsLive: destinationsService.getAttractions.bind(destinationsService),
  getHowToGetThereLive: destinationsService.getHowToGetThere.bind(destinationsService),
  getFeatures: destinationsService.getFeatures.bind(destinationsService),
  postSeed: destinationsService.postSeed.bind(destinationsService),
  getSeed: destinationsService.getSeed.bind(destinationsService),

  getPlaceDetails: placesService.getPlaceDetails.bind(placesService),

  handleApiError,
  getApiBaseUrl: getApiUrl
};

export {
  authService,
  budgetService,
  tripsService,
  activitiesService,
  healthService,
  tripFinderService,
  trendingService,
  destinationsService,
  placesService,
  apiClient,
};

export default apiService;